export enum AppAdsPlayerAvatarSize {
	Small = 30,
	Medium = 40,
}

const colors = [
	'#D251A7',
	'#D29551',
	'#D25151',
	'#6451D2',
	'#D25180',
	'#6C6C6C',
];

export const getColor = (nickName: string) => {
	const hash = nickName.split('').reduce((acc, char, index) => {
		return acc + char.charCodeAt(0) * (index + 1);
	}, 0);

	return colors[hash % colors.length];
};
